<template>
    <div class="service-info-page">
   
        <div class="main-wrapper">
            <mt-header fixed title="服务信息" style="background:#3189FF;color:#ffffff;">
                <mt-button icon="back" slot="left" @click="goBack"></mt-button>
            </mt-header>

            <div class="scroll-wrapper">
                <div class="scroll-content">
                    <ul class="service-info_wrapper" v-if="service_orders.length">
                        <li v-for="(item,index) in service_orders" :key="item.id" class="ser_items" :class="{'grayBar':index!=(service_orders.length-1)}">
                            <div class="order_title">
                                <span class="title_ball"></span>
                                <p class="header">服务信息</p>
                                <span class="pay_status" :class="{'pay':item.status ==3,'nopay':item.status ==2}">{{item.status | serStatus}}</span>
                            </div>
                            <div class="service_info">
                                <ul class="service_detail">
                                    <li><span class="label">服务名称</span><span class="no">{{item.title}}</span></li>
                                    <li><span class="label">服务费用</span><span class="money">¥ {{item.total}}</span></li>
                                    <li><span class="label">服务方案</span><span>{{item.remark}}</span></li>
                                    <li><span class="label"><i style="opacity: 0;">空</i>优惠券</span>
                                        <span class="none" v-if="!item.discount"><span></span><span>无可用</span> </span>
                                        <span class="coupon" v-if="item.discount">
                                            已使用1张<span>-¥ {{item.discount}}</span>
                                        </span>
                                    </li>
                                    <li div class="payMoney">
                                        <span>
                                            <span><i style="opacity: 0;">空</i>总计<i style="opacity: 0;">空</i></span><span class="cost">￥{{item.total}}</span>
                                        </span>
                                        <button class="service_pay" v-if="item.status == 2" @click="goPay_svr(item.sorder_no,item.total,item.creason,order.orderno)">去支付</button>
                                    </li>
                                </ul>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {Popup} from 'mint-ui';
export default {
    name:"purchase",//购买服务
    metaInfo: {
        title: '果师兄官网_苹果手机数据恢复|微信聊天记录恢复|电脑数据恢复', // set a title
        meta: [{                 // set meta
          name: 'keyWords',
          content: '果师兄恢复大师,苹果数据恢复软件,手机数据恢复软件,电脑数据恢复'
        },{                 // set meta
          name: 'description',
          content: '果师兄恢复大师为用户提供电脑手机数据恢复服务,主要服务包括微信聊 天记录,短信,备忘录,微信好友添加,照片等苹果手机数据恢复,回收站清空文件恢复,U 盘/硬 盘/SD 卡/储存卡等各类存储设备数据恢复,以及相关的数据迁移、数据删除等指导服务'
        }]
    },
    data(){
        return{
            orderno: '',
            service_orders: [],
            service_order: '',
            order: {}
        }
    },
    methods:{
        goPay_svr(sorder_no,price,remark,orderno){
            this.$router.push({name:"pay",query:{
                'orderno':orderno,
                'sorder_no':sorder_no,
                'price':price,
                'g_description': this.order.detail[0].g_description,
                'gm_name': this.service_order.title
            }})
        },
        getOrderDetail(){
            let access_token = localStorage.access_token;
            let info = {
                access_token:access_token,
                orderno:this.orderno
            }
            let vm = this;
            // Indicator.open('加载中');
            this.$store.dispatch("getOdinfo",info).then((res)=>{
                // Indicator.close();
               
                var data = res.data;
                if(data.code == 0){
                    var order = data.res.order;
                    vm.order = order
                    if(order.service && order.service.service_orders){
                        vm.service_orders = order.service.service_orders.reverse();
                        vm.service_order = _.find(vm.service_orders,(o)=>{
                            return o.status == '2'
                        })
                    }
                }
            })
        },
        goBack(){
            history.go(-1)
        }
    },
    created(){
        this.orderno = this.$route.query.orderno
        this.getOrderDetail()
    },
    mounted(){
      
    },
    components:{
        Popup
    },
    filters:{
        serStatus(val){
            if(val == 0){
                return '已作废'
            }
            if(val == 1){
                return '已取消'
            }
            if(val == 2){
                return '未支付'
            }
            if(val == 3){
                return '支付完成'
            }
        }
    }
}
</script>

<style lang="scss" scoped="" type="text/css">

</style>



// WEBPACK FOOTER //
// src/components/ServiceInfo.vue